import "./App.css";
import HeatMap from "./HeatMap";
import Fishbone from "./Fishbone";
import ChimneyChart from "./ChimneyChart";
import DataGrid from "./DataGrid";
import PughGrid from "./PughGrid";
import Timeline from "./Timeline";
import DocumentDetail from "./DocumentDetial";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { Component, Suspense, lazy, useEffect } from "react";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import i18n from "./i18n";

// React component for the BPMN workflow editor
function App() {

    const parseAndVerifyToken = (encodedToken) => {
        if (!encodedToken) {
            console.error('token参数为空');
            return null;
        }

        try {
            /*************************
             * 方式1：Base64编码的JSON格式（推荐）
             * 原始JSON示例：{"userToken":"xxx","timestamp":1735632000000}
             *************************/
            // Base64解码
            const decodedStr = atob(encodedToken); // 原生Base64解码（替代CryptoJS）
            const { userToken, timestamp } = JSON.parse(decodedStr);

            /*************************
             * 方式2：分隔符拼接格式（如 userToken_timestamp）
             * 如需此格式，注释方式1，取消注释方式2
             *************************/
            // const [userToken, timestamp] = encodedToken.split('_');
            // 转换时间戳为数字（分隔符解析需额外处理）
            // const timestampNum = Number(timestamp);
            // if (isNaN(timestampNum)) return null;

            // 验证时间戳（核心逻辑）
            const currentTime = Date.now();
            const timestampNum = Number(timestamp); // 统一转为数字

            // 校验：时间戳必须是有效数字 + 未过期 + 不是未来时间
            if (
                isNaN(timestampNum) ||
                timestampNum > currentTime || // 时间戳不能晚于当前时间（防伪造未来时间）
                currentTime - timestampNum > 5 * 60 * 1000 // 时间戳不能超过5分钟
            ) {
                console.error('token已过期或时间戳异常');
                return null;
            }

            // 验证通过，返回真实用户token
            return userToken;
        } catch (error) {
            console.error('token解析失败：', error);
            return null;
        }
    };
    const query = new URLSearchParams(window.location.search);
    const lg = query.get("lg");
    const token = query.get("token");

    React.useEffect(() => {
        const setQueryParams = () => {
            if (lg) {
                // 同步存储语言标识
                localStorage.setItem("i18nextLng", lg);
                i18n.changeLanguage(lg);
            }
            localStorage.setItem("token", token);
            //const validUserToken = parseAndVerifyToken(token);
            //if (validUserToken) {
            //    // 时间戳验证通过，存储真实用户token
            //    localStorage.setItem("token", validUserToken);
            //    console.log('token有效期内，已存储');
            //} else {
            //    // 过期/解析失败，清除无效token
            //    localStorage.removeItem("token");
            //    console.log('token已过期或解析失败，已清除本地存储');
            //}
        };
        setQueryParams();
    }, [lg, token]);

    return (
        <Suspense fallback={<div className="loading text-center">Loading...</div>}>
            <Router>
                <Routes>
                    <Route path="/fishbone" element={<Fishbone />} />
                    <Route path="/HeatMap" element={<HeatMap />} />
                    <Route path="/ChimneyChart" element={<ChimneyChart />} />
                    <Route path="/DataGrid" element={<DataGrid />} />
                    <Route path="/PughGrid" element={<PughGrid />} />
                    <Route path="/Timeline" element={<Timeline />} />
                    <Route path="/documentDetail" element={<DocumentDetail />} />
                </Routes>
            </Router>
        </Suspense>
    );
}
export default App;
